<div class="div-docment-infor-main">
  <mat-card class="mat-elevation-z0">
    <mat-card-header>
      <mat-card-title>
        <h4 class="document_info mat-panel-title">{{'header.document_auth_Info'| translate}}</h4>
      </mat-card-title>
    </mat-card-header>
    <ng-container>
      <div class="mt-1 mb-0">
        <nz-result *ngIf="signatureInfo.isValid"
                   nzStatus="success"
                   nzTitle="{{'validation.document_valid'| translate}}"
                   nzSubTitle="{{ 'validation.document_sign_on_scontract_and_not_modified'| translate :{'name':systemSignatureInfo.NameOfTheSigner,'date':systemSignatureInfo.SignedDate | dateformattime} }}">
        </nz-result>
        <nz-result *ngIf="!signatureInfo.isValid"
                   nzTitle="{{'validation.document_invalid'| translate}}"
                   nzStatus="error"
                   nzSubTitle="{{'validation.please_check_content'| translate}}">
        </nz-result>
      </div>
    </ng-container>
  </mat-card>
  <hr>
  <mat-card class="mat-elevation-z0" *ngIf="!signatureInfo.isValid">
    <div nz-result-content>
      <div class="desc">
        <h4 nz-title>{{'validation.cause_invalid' | translate}}</h4>
        <ol style="padding: 0px;">
          <li>
            <p nz-paragraph [ngStyle]="{'text-align': mediaBreakpoint !== SCREEN_SIZE.LG ? 'justify' : 'left'}">
              {{'validation.document_Not_Singed_On_SContracts'|translate}}
            </p>
          </li>
          <li>
            <p nz-paragraph [ngStyle]="{'text-align': mediaBreakpoint !== SCREEN_SIZE.LG ? 'justify' : 'left'}">
              {{'validation.without_signature_certified_viettel'| translate}}
            </p>
          </li>
          <li>
            <p nz-paragraph [ngStyle]="{'text-align': mediaBreakpoint !== SCREEN_SIZE.LG ? 'justify' : 'left'}">
              {{'validation.content_has_been_modified' | translate}}
            </p>
          </li>
        </ol>
      </div>
    </div>
  </mat-card>
  <mat-card class="mat-elevation-z0" *ngIf="signatureInfo.isValid">
    <mat-card-header>
      <mat-card-title class="document_info mat-panel-title">
        {{'header.signature_info_document'| translate}}
      </mat-card-title>
    </mat-card-header>
    <ng-container *ngFor="let info of signatureInfo.listInfo.slice(0,signatureInfo.listInfo.length -1);">
      <div class="mt-1 mb-0" [ngStyle]="{'text-align': mediaBreakpoint !== SCREEN_SIZE.LG ? 'justify' : 'left'}">
        <strong>{{'header.nameOfTheSigner'| translate}}</strong>
        <br>
        <mat-label>{{info.NameOfTheSigner}}</mat-label>
      </div>
      <div class="mt-1 mb-0" [ngStyle]="{'text-align': mediaBreakpoint !== SCREEN_SIZE.LG ? 'justify' : 'left'}" *ngIf="(info.isOtpSign || info.isImageSign) && info.certNo">
        <strong>{{'form.certification_no'| translate}}</strong>
        <br>
        <mat-label>{{info.certNo}}</mat-label>
      </div>
      <div class="mt-1 mb-0" style="text-align: justify" *ngIf="info.isOtpSign">
        <strong>{{'header.signPhone'| translate}}</strong>
        <br>
        <mat-label>{{info.signPhone}}</mat-label>
      </div>

      <div class="mt-1 mb-0" [ngStyle]="{'text-align': mediaBreakpoint !== SCREEN_SIZE.LG ? 'justify' : 'left'}">
        <strong>{{'header.signedDate'| translate}}</strong>
        <br>
        <mat-label>{{info.SignedDate | dateformattime }}</mat-label>
      </div>
      <hr/>
    </ng-container>
  </mat-card>
</div>
